import { DAAC_URL, MAAC_URL } from "@polifonia/env";
import { useTranslation } from "react-i18next";

import { ExternalLink } from "@/components/ExternalLink";

/** Where each product that can open the platform lives. */
const productLinks: Record<string, { name: string; url: string }> = {
  maac: { name: "MAAC", url: MAAC_URL },
  daac: { name: "DAAC", url: DAAC_URL },
};

interface BackToProductLinkProps {
  /** The `source` of the user's token, e.g. `"maac"`. */
  source: string | null | undefined;
}

/**
 * The platform has no sign-in of its own: users arrive from a product with a
 * token. This gives them the way back to that product.
 */
export const BackToProductLink: React.FC<BackToProductLinkProps> =
  function BackToProductLink({ source }) {
    const { t } = useTranslation();
    const product = source ? productLinks[source] : undefined;
    if (!product?.url) return null;

    return (
      <ExternalLink href={product.url} trailingIcon>
        {t("sideMenu.backToProduct", {
          product: product.name,
          defaultValue: "Back to {{product}}",
        })}
      </ExternalLink>
    );
  };
